import CreditReports from "../../components/wallets/CreditReports";

const CreditReportsPage: React.FC = () => <CreditReports />;

export default CreditReportsPage;
